export type SgpIdBetAmountColumn = "betAmount" | "payout";
export type SgpIdBetAmountIcon = "cash" | "freeCash";

export function resolveSgpIdBetAmountIcon(
  moneyType: string | null | undefined,
  column: SgpIdBetAmountColumn,
): SgpIdBetAmountIcon | null {
  if (!moneyType) {
    return null;
  }

  if (moneyType === "rebet_cash") {
    return "cash";
  }

  if (moneyType === "rebet_free_cash") {
    return column === "betAmount" ? "freeCash" : "cash";
  }

  return null;
}
